export default __webpack_public_path__ + "static/Psychedelics-Text-582a85a1dcd06207232c81cf633fae27.svg";